export default __webpack_public_path__ + "static/media/toggleBg.233db1b9.png";